/* eslint-disable no-param-reassign */
import React, { Component } from "react"
import ReactQuill, { Quill } from "react-quill";
import { I18n } from "react-redux-i18n";

import { 
  EditorAnswerWrapper, 
  EditorQuestionWrapper, 
  EditorTitle, 
  ItemsEditorWrapper 
} from "./styles";

const allowedEditorAttributes = ["underline", "strike", "italic", "bold", "link", "list"]

class TextEditor extends Component{
  constructor(props) {
    super(props)
    this.quillRefQuestion = null;       // Quill instance for question
    this.quillRefAnswer = null;         // Quill instance for answer
    this.reactQuillQuestionRef = null;  // ReactQuill component for question
    this.reactQuillAnswerRef = null;    // ReactQuill component for answer
    this.handleQuestionChange = this.handleQuestionChange.bind(this);
    this.handleAnswerChange = this.handleAnswerChange.bind(this);
  }

  componentDidMount() {
    this.attachQuillRefs("initialize")

    const bold = Quill.import("formats/bold")
    bold.tagName = "b"
    Quill.register(bold, true)
  }

  componentDidUpdate(prevProps, prevState) {
    this.attachQuillRefs()
    
    const { activeFaq } = this.props
    const { activeFaq: previousActiveFaq } = prevProps

    if(previousActiveFaq.id !== activeFaq.id) {
      this.quillRefQuestion.clipboard.dangerouslyPasteHTML(activeFaq.questionInnerHTML)
      this.quillRefAnswer.clipboard.dangerouslyPasteHTML(activeFaq.answerInnerHTML)
      this.quillRefQuestion.focus()
    }
  }

  removeTextAttributes = (_, delta) => {
    delta.ops = delta.ops.map(op => {
      const { attributes, insert } = op
      if(attributes) {
        const attributeList = Object.keys(attributes)
        let newAttributes = {}
        attributeList.forEach(attribute => {
          const isAllowed = allowedEditorAttributes.find(item => attribute === item)
          if(isAllowed) {
            newAttributes = { ...newAttributes, [attribute]: attributes[attribute]}
          }
        })
        return {
          insert,
          attributes: newAttributes
        }
      }
      return op
    })
    return delta
  }

  attachQuillRefs = (option) => {
    try {
      if (typeof this.reactQuillQuestionRef.getEditor !== "function") return;
      this.quillRefQuestion = this.reactQuillQuestionRef.getEditor();
      this.quillRefAnswer = this.reactQuillAnswerRef.getEditor()
      if(option === "initialize") {
        this.quillRefQuestion.clipboard.addMatcher(Node.ELEMENT_NODE, this.removeTextAttributes)
        this.quillRefAnswer.clipboard.addMatcher(Node.ELEMENT_NODE, this.removeTextAttributes)
      }
    } catch (error) {
      console.log(error)
    }
  }

  handleQuestionChange = (value) => {
    console.log('mudou')
    const { faq, activeFaq, handleFaqUpdate } = this.props
    const { id: activeQuestionId } = activeFaq

    if(this.quillRefQuestion) {
      const questionInputText = this.quillRefQuestion.getText()
      let questionText = String(questionInputText)
  
      if(questionText.length > 75) {
        questionText = `${questionText.substring(0, 74)}...`
      } 
      
      const updatedFaq = faq.map(item => {
        if(item.id === activeQuestionId) {
          return {
            ...item,
            questionInnerHTML: value,
            questionText
          }
        }
        return item
      })
  
      handleFaqUpdate(updatedFaq)
    }
  }

  handleAnswerChange = (value) => {
    const { faq, activeFaq, handleFaqUpdate } = this.props
    const { id: activeQuestionId } = activeFaq

    if(this.quillRefQuestion) {
      const answerText = this.quillRefAnswer.getText()
  
      const updatedFaq = faq.map(item => {
        if(item.id === activeQuestionId) {
          return {
            ...item,
            answerInnerHTML: value,
            answerText
          }
        }
        return item
      })
  
      handleFaqUpdate(updatedFaq)
    }
  }

  wordCounter = (text) => {
    const textBreakFilter = text.replace(/(\r\n|\r|\n|\t)/g, " ")
    const textBlankFilter = textBreakFilter.replaceAll(/\s+/g, " ")
    return textBlankFilter.split(" ").filter(char => char !== "").length
  }

  render() {
    const { activeFaq, locale } = this.props
    
    return (
      <ItemsEditorWrapper locale={locale}>
        <EditorTitle>{I18n.t("editPanel.FAQManager.editorTitle")}</EditorTitle>
        <EditorQuestionWrapper>
          <p>{I18n.t("editPanel.FAQManager.editorQuestion")}</p>
          <ReactQuill 
            ref={(el) => { this.reactQuillQuestionRef = el }}
            defaultValue={activeFaq.questionInnerHTML} 
            onChange={this.handleQuestionChange} 
            modules={{
              toolbar: [['bold', 'italic', 'underline', 'strike']]
            }}
          />
        </EditorQuestionWrapper>
        <EditorAnswerWrapper>
          <p>{I18n.t("editPanel.FAQManager.editorAnswer")}</p>
          <ReactQuill 
            ref={(el) => { this.reactQuillAnswerRef = el }}
            defaultValue={activeFaq.answerInnerHTML} 
            onChange={this.handleAnswerChange} 
            modules={{
              toolbar: [['bold', 'italic', 'underline', 'strike'], ['link'], [{ 'list': 'ordered' }, { 'list': 'bullet' }]]
            }}
          />
          <p className="wordsCounter">
            <span>
              {I18n.t("editPanel.FAQManager.wordsCounter")}:{" "}
              {this.wordCounter(activeFaq.answerText)}
            </span>
            <span>
              {I18n.t("editPanel.FAQManager.charactersCounter")}:{" "}
              {activeFaq.answerText.length - 1}
            </span>
          </p>
        </EditorAnswerWrapper>
      </ItemsEditorWrapper>
    )
  }
}

export default TextEditor;